import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as Action from './actions'

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listSinhNhatRequestApi (formData) {
  const request = axiosApi().post(
    Constants.DASHBOARD_SINHNHAT_LIST_API, 
    formData
  )

  return handleRequest(request);
}

function* dashboardSinhNhatListRequestFlow ({ formData }) {
  try {
    // grab the client from our action
    const results = yield call(listSinhNhatRequestApi, formData)
    const data = JSON.parse(results.data)
    // dispatch the action with our widgets!
    yield put(Action.dashboardSinhNhatListSuccess(data))

  } catch (error) {
    yield put(Action.dashboardSinhNhatListError(error))
  }
}

function* dashboardWatcher () {
  yield [
    takeLatest(Constants.DASHBOARD_SINHNHAT_LIST_REQUESTING, dashboardSinhNhatListRequestFlow),
  ]
}

export default dashboardWatcher



// WEBPACK FOOTER //
// ./src/views/Dashboard/sagas.js